/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!**********************************************!*\
  !*** ./src/scripts/collection/collection.js ***!
  \**********************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var collection = function collection() {
  return {
    mobileFiltersShow: false,
    body: null,
    dropdowns: null,
    openDetailElement: null,
    init: function init() {
      this.body = document.querySelector('body');
      this.dropdowns = document.querySelectorAll('.filter-dropdown');
      this.setFiltersBarTopPosition();
      window.addEventListener('resize', this.setFiltersBarTopPosition);
      window.addEventListener('scroll', this.setFiltersBarTopPosition);
    },
    openMobileFilters: function openMobileFilters() {
      this.mobileFiltersShow = true;
      this.body.style.overflow = 'hidden';
    },
    closeMobileFilters: function closeMobileFilters() {
      this.mobileFiltersShow = false;
      this.body.style.overflow = 'visible';
    },
    openDropDown: function openDropDown(el) {
      if (this.dropdowns) {
        this.dropdowns.forEach(function (element) {
          element.removeAttribute('open');
          if (element !== el) {
            element.removeAttribute("open");
          }
        });
      }
    },
    setFiltersBarTopPosition: function setFiltersBarTopPosition() {
      var header = document.querySelector('header');
      var height = header.offsetHeight;
      var body = document.querySelector('body');
      var filtersPanel = document.querySelector('.fixed-filters');
      if (filtersPanel) {
        if (body.classList.contains('scroll-down')) {
          filtersPanel.style.top = 0;
        } else {
          filtersPanel.style.top = height + 'px';
        }
      }
    }
  };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (collection);
document.addEventListener("alpine:init", function () {
  Alpine.data("collection", collection);
});
/******/ })()
;